import { memo } from 'react'
import { Theme, Typography } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'

import { IPayoutDuration, PAYOUT_DURATION_MAP } from './typings'

const useStyles = makeStyles<Theme, { isPayoutDurationVisible: boolean }>(
  (theme: Theme) =>
    createStyles({
      payoutDurationCls: {
        display: ({ isPayoutDurationVisible }) =>
          isPayoutDurationVisible ? 'flex' : 'none',
        flexDirection: 'column',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        justifyContent: 'center',
        height: '100%',
        paddingLeft: 20,
        [theme.breakpoints.down('md')]: {
          borderRight: 'none',
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          margin: '10px 20px',
          paddingLeft: 10,
        },
      },
      headerText: {
        fontWeight: '700',
        fontSize: 18,
        marginTop: -40,
        [theme.breakpoints.down('md')]: {
          marginTop: 40,
        },
      },
      payoutText: {
        fontWeight: '500',
        fontSize: 44,
      },
      payoutDaysText: {
        fontWeight: '400',
        fontSize: 12,
        marginLeft: 5,
      },
    }),
)

const PayoutDuration = ({ duration }: IPayoutDuration) => {
  const { payoutDurationCls, headerText, payoutText, payoutDaysText } =
    useStyles({
      isPayoutDurationVisible:
        duration !== PAYOUT_DURATION_MAP.unknown && !!duration,
    })
  return (
    <div className={payoutDurationCls}>
      <Typography className={headerText}>Sie bekommen das Geld in</Typography>
      <Typography className={payoutText}>
        {PAYOUT_DURATION_MAP[duration]}
      </Typography>
      <Typography className={payoutDaysText}>TAGE</Typography>
    </div>
  )
}

export default memo(PayoutDuration)
